module.exports = __webpack_public_path__ + "fonts/Muli_Bold--ef0ddd4c3565d4840dc2f11345cf1c02.ef0ddd4c3565d4840dc2f11345cf1c02.woff";